interface Props {
  message: string;
  onRetry: () => void;
}

export function LoadError({ message, onRetry }: Props) {
  return (
    <div className="max-w-xl rounded-xl border border-[var(--co-border)] bg-[var(--co-surface)] p-4">
      <p role="alert" className="mb-3 text-[13px] text-[var(--co-error)]">
        Error: {message}
      </p>
      <button
        type="button"
        onClick={onRetry}
        className="rounded-lg border border-[var(--co-border)] px-3 py-2 text-[12px] font-medium text-[var(--co-text)] hover:bg-[var(--co-border)]/30"
      >
        Retry
      </button>
    </div>
  );
}
